// LIBRARIES
import styled, { css } from "styled-components";

// MISC

import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  FONT_FAMILY,
  FONT_WEIGHT,
  MARGIN,
  SIZE,
} from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const GirdleContainer = styled.header`
padding: 12px 16px;
width: 100%;
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-around;
height: 70px;
border-top-left-radius: ${BORDER_RADIUS.radius24};
  border-top-right-radius: ${BORDER_RADIUS.radius24};
   background:
    radial-gradient(
      circle at 25% 40%,
      #1a4b86 0%,
      #0e335f 30%,
      #08243f 60%,
      #051a2d 100%
    );
@media (max-width: ${DEVICE_TYPE.mobile}) {
  flex-direction: column;
  align-items: center;
  padding: 10px;
  height: 90px;
  }
`;

export const BoxWrapper = styled.div`
cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
border-left: 2px solid ${COLORS.AbsoluteWhite};
padding: 0 16px;
@media (max-width: ${DEVICE_TYPE.mobile}) {
border-left: none;
border-bottom: 2px solid ${COLORS.AbsoluteWhite};
padding: 10px;
  }
`;
